export default "__VITE_ASSET__dbb0fc8b__"